 import { JSX } from "react";
import { Navigate, useLocation } from "react-router-dom";

export const PublicRoute = ({ children }: { children: JSX.Element }) => {
  const token = localStorage.getItem("accessToken");
  const location = useLocation();

  // Allow access to public routes (like /login) when coming from the
  // admin "switch company" flow, even if a token already exists.
  // This lets the Login page handle switching the company context.
  const searchParams = new URLSearchParams(location.search);
  const hasAdminSwitchParams =
    searchParams.has("authToken") &&
    (searchParams.has("id") || searchParams.has("switchCompanyId"));

  // Set by auth-service's oauth-authorize.ts (dev-console SSO / MCP OAuth). Always show the real
  // login form here rather than trying to silently resume with whatever token happens to be in
  // localStorage: this app is multi-tenant (different subdomains = different localStorage), so
  // an existing token here isn't reliably valid for the flow that's asking, and auth-service has
  // no way to tell us "that token was rejected" other than 302'ing right back to this same URL --
  // which, if we auto-retried, would loop forever. Requiring an explicit (re-)login here is the
  // one guaranteed-no-loop option; Login.tsx's own resumeOAuthReturnUrl() carries the fresh token
  // back to auth-service once the user actually submits the form.
  const returnUrlParam = searchParams.get("return_url");
  if (returnUrlParam) {
    return children;
  }

  if (token && !hasAdminSwitchParams) {
    const previous = (location.state as any)?.from;
    return <Navigate to={previous || "/dashboard"} replace />;
  }

  return children;
};
